import { ContactUpdate } from "../models/contact-update";
import { patch } from "./utils";

export const updateContact = async (contact: ContactUpdate) => await patch(`contacts/selected`, contact);
